module.exports = __webpack_public_path__ + "static/media/file-plus.891fd6cc.svg";